import styled from 'styled-components'
import { type StoreLogo } from '@/features/cms/components/CMS/types'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { Body } from '@shipt/design-system-typography'

export const StoreIcons = ({ availableStores }: { availableStores?: StoreLogo[] }) => {
  return (
    <TeaserContainer>
      {availableStores?.slice(0, 3).map((storeLogo, i) => {
        const {
          data: {
            retailer_id,
            logo: { src },
            name,
          },
        } = storeLogo
        const remainingStores = i < 2 ? 0 : availableStores.length - 2
        return (
          <StoreWrapper zIndex={i} key={retailer_id}>
            {remainingStores > 1 ? (
              <RemainingStores>
                <Body size="md" surface="inverse">
                  +{remainingStores}
                </Body>
              </RemainingStores>
            ) : (
              <CircularImage
                src={src}
                fallbackType="product"
                alt={`Promotion available at ${name}`}
                width={36}
                height={36}
              />
            )}
          </StoreWrapper>
        )
      })}
    </TeaserContainer>
  )
}

const TeaserContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  z-index: 1;
`

const StoreWrapper = styled.div<{ zIndex: number }>`
  background-color: white;
  border-radius: 100%;
  border: solid 2px;
  width: 40px;
  height: 40px;
  border-color: white;
  margin-left: -8px;
  z-index: ${({ zIndex }) => -zIndex};
`

const RemainingStores = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background-color: rgb(24 12 32);
`

const CircularImage = styled(Image)`
  border-radius: 50%;
`
